// @flow

import React from 'react'

export default ({
  fromLabel,
  toLabel,
  fromOptions,
  toOptions,
  fromOnChange,
  toOnChange,
  fromValue,
  toValue,
}) => {
  const fromPlaceHolderStyle = fromValue === '' ? { color: '#d1d1d1' } : {}
  const toPlaceHolderStyle = toValue === '' ? { color: '#d1d1d1' } : {}

  return (
    <div className="search-side__item-duratoin">
      <div className="search-side__select-small">
        <select
          name="reserve_style"
          onChange={fromOnChange}
          style={fromPlaceHolderStyle}
        >
          <option value="">{fromLabel}</option>
          {fromOptions.map((item, index) => (
            <option
              value={item['id']}
              selected={item['id'] === fromValue}
              key={`from_option_${index}`}
            >
              {item['label']}
            </option>
          ))}
        </select>
      </div>
      <div className="search-side__item-duration-tilde">〜</div>
      <div className="search-side__select-small">
        <select
          name="reserve_style"
          onChange={toOnChange}
          style={toPlaceHolderStyle}
        >
          <option value="">{toLabel}</option>
          {toOptions.map((item, index) => (
            <option
              value={item['id']}
              selected={item['id'] === toValue}
              key={`to_option_${index}`}
            >
              {item['label']}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/SearchRangeSelectField.jsx